module.exports = __webpack_public_path__ + "img/30f4.3b98a65c.jpg";